import { css } from '@emotion/react';

const mobileContainerHeightCSS = css`
    height: 100vh;
    /* CSS specific to iOS devices */
    @supports (-webkit-touch-callout: none) {
        height: ${`-webkit-fill-available`};
    }
`;

export default mobileContainerHeightCSS;
